import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { contentStyles, h1, tickedBullet } from '@helpers/typography';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import { ButtonStyles } from '@stories/Components/Buttons/Button/Button.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Inner = styled.div `
  @media ${from(Device.Tablet)} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: end;

    ${Container}[data-inner-width="reduced"] & {
      grid-template-columns: repeat(9, 1fr);
    }
  }
`;
const Text = styled.div `
  position: relative;
  padding: 30px 0 8em;
  margin-bottom: -6.5em;
  color: ${brand.white};

  @media ${from(Device.Tablet)} {
    display: flex;
    flex-direction: column;
    min-height: 464px;
    padding: 40px 16.67% 20px ${fluid(40, 60)};
    margin-bottom: 0;

    ${Container}[data-inner-width="reduced"] & {
      grid-column: span 5;
      padding-right: ${fluid(40, 60)};
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: calc(var(--sitePadding) * -1);
    width: calc(100% + var(--sitePadding) * 2);
    height: 100%;
    background-color: var(--themeColor);

    @media ${from(Device.Tablet)} {
      width: 116.67%;
      left: 0;

      ${Container}[data-inner-width="reduced"] & {
        width: 136%;
      }
    }
  }

  ${Container}[data-component-theme='white'] & {
    color: ${brand.black};

    &::before {
      --themeColor: ${brand.white};
      border: 2px solid ${brand.orange};
      top: 1px;
      width: calc(100% + var(--sitePadding) * 2 - 4px);
      height: calc(100% - 4px);
    }
  }
`;
const ImageWrapper = styled.div `
  position: relative;
  width: calc(100% + var(--sitePadding));
  border: 2px solid var(--themeColor);

  @media ${from(Device.Tablet)} {
    width: auto;
    min-height: 378px;

    ${Container}[data-inner-width="reduced"] & {
      grid-column: 6 / span 4;
    }
  }

  ${Container}[data-component-theme='white'] & {
    --themeColor: ${brand.orange};
  }

  img {
    max-width: none;
    width: 100%;
    height: auto;

    @media ${from(Device.Tablet)} {
      position: absolute;
      height: 100%;
      object-fit: cover;
    }
  }
`;
const Heading = styled.h2 `
  position: relative;
  ${h1};

  ${Container}[data-component-theme='white'] & {
    color: ${brand.orange};
  }
`;
const Content = styled.div `
  position: relative;
  ${contentStyles};
  ${tickedBullet};

  p,
  ol li,
  ul li {
    ${fonts.agBook.regular};
  }

  ul li {
    &::before {
      background-color: var(--themeColor);

      ${Container}[data-component-theme='white'] & {
        --themeColor: ${brand.black};
        filter: invert(1);
      }
    }
  }

  a,
  p a {
    &:not(${ButtonStyles.Button}):not([class*='button-style']) {
      ${Container}[data-component-theme]:not([data-component-theme='white']) & {
        color: ${brand.white};
      }
    }
  }
`;
const Link = styled(LinkButton) `
  margin-top: 1.5em;

  @media ${from(Device.Tablet)} {
    margin-top: auto;
  }
`;
export const ImageText5050Styles = {
    Container,
    Content,
    Heading,
    ImageWrapper,
    Inner,
    Link,
    Text,
};
